export default {
    'ERROR-GET-SUPPORT-ADMIN-USER': {
        'RELATION-NOT-FOUND': {
            actionType: '',
            message: {
                fr: "La relation demandée est introuvable.",
                en: 'The requested relation was not found.',
            },
        },
        'NO-USER-FOUND': {
            actionType: '',
            message: {
                fr: "Utilisateur introuvable.",
                en: 'User not found.',
            },
        },
        'NO-ADMIN-FOUND': {
            actionType: '',
            message: {
                fr: "Aucun administrateur trouvé pour cette campagne.",
                en: 'No admin found for this campaign.',
            },
        },
    },
    'ERROR-POST-MESSAGE-SUPPORT': {
        'NO-ADMIN-FOUND': {
            actionType: '',
            message: {
                fr: "L'administrateur spécifié est introuvable.",
                en: 'The specified admin was not found.',
            },
        },
        'NO-USER-FOUND': {
            actionType: '',
            message: {
                fr: "Utilisateur introuvable.",
                en: 'User not found.',
            },
        },
    },
};
